<template>
  <v-btn @click="signIn" class="my-2 text-none" color="#2a6fc3" size="large" variant="elevated" block>
    <LanguagePlaceholder default-text="Dell Technologies staff login" />
  </v-btn>
</template>

<script>
import authService from '@/services/auth';
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue';
import { useSystemStore } from '@/stores/system';

export default {
  name: 'OktaSignIn',
  components: {
    LanguagePlaceholder
  },
  methods: {
    async signIn() {
      try {
        // Clear any existing auth state that might be causing conflicts
        try {
          await authService.oktaAuth.tokenManager.clear();
          authService.oktaAuth.transactionManager.clear();
          
          // Also clear any SSO session storage items (keep ssoIntendedPath for post-login redirect)
          sessionStorage.removeItem('fromOktaCallback');
          sessionStorage.removeItem('oktaAuthCode');
          sessionStorage.removeItem('oktaState');
          sessionStorage.removeItem('oktaError');
          sessionStorage.removeItem('oktaErrorDescription');
          sessionStorage.removeItem('oktaCallbackUrl');
          
        } catch (clearError) {
          console.warn('Warning: Could not clear existing auth state:', clearError);
        }

        // Determine where to send the user after SSO. If they were sent to login from a
        // deep link, use that requested route; otherwise use current URL. Persist in
        // sessionStorage so it survives the full-page redirect to Okta and back.
        const systemStore = useSystemStore();
        let intendedPath = window.location.hash.replace('#/', '') || '/';
        if (systemStore.requestedRoute && systemStore.requestedRoute.trim() !== '' && systemStore.requestedRoute !== 'login') {
          const resolved = this.$router.resolve({ name: systemStore.requestedRoute });
          if (resolved?.path) {
            intendedPath = resolved.path.replace(/^\//, '') || intendedPath;
          }
        }
        sessionStorage.setItem('ssoIntendedPath', intendedPath);
        authService.setOriginalUri(intendedPath);
        
        // Redirect to Okta for authentication
        await authService.signInWithRedirect();
      } catch (error) {
        console.error('Okta sign-in error:', error);
        console.error('Error details:', error);
        this.$emit('error', 'Failed to initiate Okta sign-in');
      }
    }
  }
};
</script>